export default __webpack_public_path__ + "static/media/ies_header_voces.a84fe6e6.png";